import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { cancelSlot } from './api';

export function useCancelSlot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ slotId, reason }: { slotId: number; reason?: string }) => cancelSlot(slotId, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.appointments.slots() });
    },
  });
}
